import React from "react";

export default function RefreshIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75321 3.04008C5.71266 3.09642 4.72298 3.50823 3.94961 4.20668C3.17624 4.90512 2.66606 5.84787 2.50434 6.87732C2.34262 7.90677 2.53918 8.96054 3.06114 9.86246C3.5831 10.7644 4.39885 11.4598 5.372 11.8325C6.34516 12.2052 7.41675 12.2325 8.40765 11.9099C9.39854 11.5874 10.2487 10.9345 10.816 10.0603C11.3832 9.18617 11.6333 8.1438 11.5243 7.10744C11.4152 6.07108 10.9538 5.10355 10.217 4.36658L10.7123 3.87133C11.5564 4.71551 12.0876 5.82216 12.2182 7.00877C12.3489 8.19538 12.0712 9.3911 11.4311 10.3987C10.7909 11.4063 9.82646 12.1657 8.69676 12.5516C7.56706 12.9375 6.33958 12.9268 5.21675 12.5214C4.09392 12.1159 3.1428 11.3399 2.52023 10.3213C1.89766 9.30275 1.64082 8.10239 1.79208 6.91823C1.94333 5.73407 2.49364 4.63681 3.35226 3.80741C4.21088 2.97801 5.32652 2.46601 6.51521 2.35583L5.82105 1.66166L6.31688 1.16699L7.76005 2.61074C7.81473 2.66544 7.84544 2.73961 7.84544 2.81695C7.84544 2.89429 7.81473 2.96846 7.76005 3.02316L7.4713 3.31191L6.3163 4.46691L5.82163 3.97166L6.75321 3.04008Z"
        fill="#FF752C"
      />
    </svg>
  );
}
